import axios from "axios";

export const train_status=async()=>{
    return await axios.get(`https://health.neuronai.life/train_status`);
}